<template>
  <div>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.type"
      placeholder="课程类型"
      :clearable="true"
      @change="query.page = 1; searchList()"
    >
      <el-option label="体验营" value="102">体验营</el-option>
      <el-option label="入门课" value="100">入门课</el-option>
      <el-option label="百元课" value="101">百元课</el-option>
      <el-option label="正价课" value="103">正价课</el-option>
      <el-option label="初级协导班" value="104">初级协导班</el-option>
      <el-option label="初级证照班" value="105">初级证照班</el-option>
      <el-option label="深度课" value="106">深度课</el-option>
      <el-option label="高级协导班" value="107">高级协导班</el-option>
      <el-option label="高级证照班" value="108">高级证照班</el-option>
      <el-option label="能量朗读" value="2">能量朗读</el-option>
      <el-option label="直播" value="3">直播</el-option>
      <el-option label="晚安调频" value="4">晚安调频</el-option>
      <el-option label="工作坊" value="5">工作坊</el-option>
      <el-option label="听书" value="6">听书</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="searchList()"> 查询 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          label="课程类型"
          align="center"
          min-width="20%"
          prop="type_title"
        ></el-table-column>
        <el-table-column
            label="课程名称"
            align="center"
            min-width="20%"
            prop="title"
        ></el-table-column>
        <el-table-column
            label="学习时长"
            align="center"
            min-width="20%"
            prop="total_duration"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getUserStudyList} from "@/api/user";
/*import { getAllAgent } from "@/api/agent";*/
/*const axios = require('axios');*/

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      agentList: [],
      query: {
        page: 1,
        limit: 20,
        type: '',
        user_id: this.$route.query.id
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime()-24*60*60*1000);
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime()-1);
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created: function () {
    this.getList();
    /*getAllAgent().then((res) => {
      if (res.status === "2000") {
        this.agentList = res.data.list;
      }
    });*/
  },
  methods: {
    getList() {
      this.loading = true;
      getUserStudyList(this.query).then((response) => {
        this.list = response.data.list;
        /*if (this.total == 0) {*/
          this.total = response.data.total;
        /*}*/
        this.loading = false;
      });
    },


    searchList() {
      this.loading = true;
      getUserStudyList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    /*exportUser() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/user/getUserStudyList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        //console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '用户列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }*/
  },
  mounted() {},
};
</script>